import React from "react";
import {
  Box,
  Typography,
  Button,
  Link,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Projectcolors from "../../Utils/Colors";

const SubNavbar = ({ handleOpen, handleOpenc, home }) => {
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const toggleDrawer = (open) => () => {
    setMobileOpen(open);
  };

  const menuItems = (
    <List sx={{ width: 250 }}>
      {home && (
        <ListItem button component="a" href="/">
          <ListItemText primary="HOME" sx={{ color: Projectcolors.primary, fontWeight: "bold" }} />
        </ListItem>
      )}
      <ListItem button component="a" href="/blogs">
        <ListItemText primary="OUR BLOGS" sx={{ color: Projectcolors.primary, fontWeight: "bold" }} />
      </ListItem>
      <ListItem button component="a" href="/aboutpage">
        <ListItemText primary="ABOUT" sx={{ color: Projectcolors.primary, fontWeight: "bold" }} />
      </ListItem>
      <ListItem button onClick={handleOpenc}>
        <ListItemText primary="CONTACT" sx={{ color: Projectcolors.primary, fontWeight: "bold" }} />
      </ListItem>
      <ListItem button component="a" href="/login">
        <ListItemText
          primary="SIGN IN"
          sx={{ color: Projectcolors.primary, fontWeight: "bold" }}
        />
      </ListItem>
    </List>
  );

  return (
    <Box
      component="nav"
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        p: 2,
      }}
    >
      {/* Desktop Links */}
      <Box
        sx={{
          display: { xs: "none", md: "flex" }, // hide on mobile, show on desktop
          gap: 2,
        }}
      >
        {home && (
          <Typography>
            <Link
              href="/"
              sx={{ textDecoration: "none", color: "#80e5ff", fontWeight: "bold" }}
            >
              HOME
            </Link>
          </Typography>
        )}
        <Typography
                  sx={{ display: "inline", padding: 1, fontSize: 16, marginRight: 2 }}
                >
                  <Button sx={{ color: "#80e5ff", fontSize: 16 }}>
                  <Link
                    href="/aboutpage"
                    sx={{ textDecoration: "none",color: "#80e5ff", fontSize: 16,"&:hover": {
              color: "#80e5ff", // Prevent color change
              textDecoration: "none", // Prevent underline
            }, }}
                    
                  >
                    <b>ABOUT</b>
                    </Link>
                  </Button>{" "}
                  
                </Typography>
                <Typography
                  sx={{ display: "inline", padding: 1, fontSize: 16, marginRight: 2 }}
                >
                  <Button sx={{ color: "#80e5ff", fontSize: 16 }}>
                  <Link
                    href="/blogs"
                    sx={{ textDecoration: "none",color: "#80e5ff", fontSize: 16,"&:hover": {
              color: "#80e5ff", // Prevent color change
              textDecoration: "none", // Prevent underline
            }, }}
                    
                  >
                    <b>OUR BLOGS</b>
                    </Link>
                  </Button>{" "}
                  
                </Typography>
       <Typography
                 sx={{ display: "inline", padding: 1, fontSize: 16, marginRight: 2 }}
               >
                 <Button onClick={handleOpenc} sx={{ color: "#80e5ff", fontSize: 16 }}>
                   <b>CONTACT</b>
                 </Button>{" "}
               </Typography>
        <Typography
                  sx={{
                    display: "inline",
                    padding: 1,
                    fontSize: 16,
                    backgroundColor: "white",
                    borderRadius: "10%",
                    marginRight: 7,
                    marginTop:1,
                    marginBottom:1

                  }}
                >
                  <Link
                    href="/login"
                    sx={{ textDecoration: "none", color: Projectcolors.primary }}
                  >
                    <b>SIGN IN </b>
                  </Link>
                </Typography>
      </Box>

      {/* Mobile Hamburger */}
      <IconButton
        sx={{ display: { xs: "block", md: "none" }, color: "#80e5ff" }}
        onClick={toggleDrawer(true)}
      >
        <MenuIcon />
      </IconButton>

      {/* Drawer for Mobile Menu */}
      <Drawer anchor="right" open={mobileOpen} onClose={toggleDrawer(false)}>
        {menuItems}
      </Drawer>
    </Box>
  );
};

export default SubNavbar;
